import React from "react";

import { number, string } from "prop-types";

import "./Headline.m.css";

const Headline = ({ children, type, customStyleName, customClassName }) => {
  const Tag = `h${type}`;
  return (
    <Tag styleName={`${Tag}-style ${customStyleName}`} className={`headline ${customClassName}`}>
      {children}
    </Tag>
  );
};

Headline.defaultProps = {
  customStyleName: "",
  type: 1,
};

Headline.propTypes = {
  type: number.isRequired,
  customStyleName: string.isRequired,
};

export default Headline;
